export default (value) => {
  if(!value)
    return null;

  return JSON.parse(value);
};
